import ApiProvider from "@/components/ApiProvider";
import {
  FacebookIcon,
  InstagramIcon,
  TwitterIcon,
  YouTubeIcon,
} from "@/components/SocialMediaIcons";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
} from "@/components/ui/carousel";
import Autoplay from "embla-carousel-autoplay";
import { ChevronLeft, ChevronRight, ExternalLink, Mail, MapPin, Pause, Phone, Play } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useGetFooterImagesListQuery } from "../../services/Redux/Features/FooterSlice";
import StatCounter from "@/components/StatCounter";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useLogo } from "@/context/LogoContext";
import type { EmblaCarouselType } from "embla-carousel";

const Footer = () => {
  const { t: _ } = useTranslation();

  const [galleryToggleplay, setGalleryToggleplay] = useState(true);
  const [emblaApi, setEmblaApi] = useState<EmblaCarouselType | null>(null);

  const { revenueLogo } = useLogo();

  const footerImageQueryRes = useGetFooterImagesListQuery();

  const currentDate = new Date()
  const formattedDate = currentDate.toLocaleDateString('en-GB').replace(/\//g, '-')


  const handleSetApi = useCallback(
    (api: EmblaCarouselType | undefined) => {
      if (api) setEmblaApi(api);
    },
    []
  );

  const autoplayRef = useRef(
    Autoplay({
      delay: 3000,
      stopOnInteraction: false,
    })
  );

  const handlePrev = useCallback(() => {
    emblaApi?.scrollPrev();
  }, [emblaApi]);

  const handleNext = useCallback(() => {
    emblaApi?.scrollNext();
  }, [emblaApi]);

  const toggleAutoplay = useCallback(() => {
    const autoplay = autoplayRef.current;
    if (!autoplay) return;

    if (autoplay.isPlaying()) {
      autoplay.stop();
    } else {
      autoplay.play();
    }
  }, []);

  useEffect(() => {
    if (!emblaApi) return;

    const autoplay = autoplayRef.current;

    const onPlay = () => setGalleryToggleplay(true);
    const onStop = () => setGalleryToggleplay(false);

    emblaApi.on("autoplay:play", onPlay);
    emblaApi.on("autoplay:stop", onStop);

    setGalleryToggleplay(autoplay.isPlaying());

    return () => {
      emblaApi.off("autoplay:play", onPlay);
      emblaApi.off("autoplay:stop", onStop);
    };
  }, [emblaApi]);

  return (
    // <div>
    //   <div className="w-full flex justify-center bg-white py-6 px-4">
    //     <ApiProvider
    //       isError={footerImageQueryRes.isError}
    //       error={footerImageQueryRes.error}
    //       isLoading={footerImageQueryRes.isFetching}
    //    >
    //       <div className="relative items-center">
    //         <Carousel
    //           opts={{ align: "start", loop: true }}
    //           plugins={[autoplayRef.current]}
    //           setApi={handleSetApi}
    //           className="w-full"
    //        >
    //           <CarouselContent>
    //             {footerImageQueryRes.data?.items.map((item) => (
    //               <CarouselItem
    //                 key={item.id}
    //                 className="basis-1/2 sm:basis-1/3 md:basis-1/4 lg:basis-1/6"
    //              >
    //                 <a
    //                   href={item.link?.toString()}
    //                   target="_blank"
    //                   rel="noopener noreferrer"
    //                >
    //                   <div
    //                     className="flex items-center justify-center h-28 rounded-xl bg-[#eef3f6] transition hover:shadow-md">
    //                     <img
    //                       src={item.imagePath}
    //                       alt={`Footer Government Link ${item.id}`}
    //                       className="max-h-16 max-w-full object-contain"
    //                       loading="lazy"
    //                     />
    //                   </div>
    //                 </a>
    //               </CarouselItem>
    //             ))}
    //           </CarouselContent>
    //           <div className="mt-4 flex w-full justify-end">
    //             <div className="inline-flex items-center rounded-full bg-[#5e826c] shadow-md overflow-hidden"
    //               aria-label="Gallery controls"
    //            >
    //               <button
    //                 onClick={handlePrev}
    //                 aria-label="Previous slide"
    //                 className="flex h-10 w-10 items-center justify-center text-white transition hover:bg-[#3e6b4f] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/80">
    //                 <ChevronLeft className="h-5 w-5" />
    //               </button>

    //               <button
    //                 onClick={toggleAutoplay}
    //                 aria-label={galleryToggleplay ? "Pause gallery autoplay" : "Start gallery autoplay"}
    //                 aria-pressed={galleryToggleplay}
    //                 className="flex h-10 w-10 items-center justify-center text-white border-x border-white/20 transition hover:bg-[#3e6b4f] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/80">
    //                 {galleryToggleplay ? (
    //                   <Pause className="h-4 w-4" />
    //                 ) : (
    //                   <Play className="h-4 w-4" />
    //                 )}
    //               </button>

    //               <button
    //                 onClick={handleNext}
    //                 aria-label="Next slide"
    //                 className="flex h-10 w-10 items-center justify-center text-white transition hover:bg-[#3e6b4f] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/80">
    //                 <ChevronRight className="h-5 w-5" />
    //               </button>
    //             </div>
    //           </div>
    //         </Carousel>
    //       </div>
    //     </ApiProvider>
    //   </div>
    <footer className="bg-theme-green w-full text-white transition-colors duration-300">
      <div className="container mx-auto px-4 py-10 sm:py-16">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-2 lg:grid-cols-12 lg:gap-8">
          <div className="lg:col-span-5 space-y-6">
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
              <div className="relative flex-shrink-0 bg-white/10 rounded-lg p-1">
                <img
                  src={revenueLogo}
                  alt="Revenue Department Govt of Maharashtra"
                  width="56"
                  height="56"
                  loading="lazy"
                  className="h-14 w-14 object-contain"
                  style={{ aspectRatio: '1/1' }}
                />
              </div>
              <div className="space-y-1">
                <h3 className="text-xl font-bold leading-tight tracking-tight sm:text-2xl">
                  {_("footer.project.title")}
                </h3>
                <p className="text-sm font-medium text-teal-400 uppercase tracking-wider">
                  {_("footer.project.description")}
                </p>
              </div>
            </div>
            <p className="text-sm leading-relaxed text-gray-300 max-w-2xl lg:max-w-md">
              {_("footer.project.description.long")}
            </p>
          </div>

          <div className="lg:col-span-3 space-y-6">
            <h3 className="text-lg font-semibold border-b border-white/10 pb-2 inline-block">
              {_("Footer.Head.Title4")}
            </h3>
            <nav className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-1 gap-y-3 gap-x-4">
              {[
                { to: "/dashboard", label: "Footer.MoreLinks9" },
                { to: "/policies", label: "Footer.MoreLinks1" },
                { to: "/accessibility_statement", label: "Footer.MoreLinks10" },
                { to: "/help", label: "Footer.MoreLinks3" },
                { to: "/contact_us", label: "Footer.MoreLinks5" },
                { to: "/sitemap", label: "Footer.MoreLinks6" },
                { to: "/feedback", label: "Footer.MoreLinks7" },
              ].map((link, idx) => (
                <Link
                  key={idx}
                  to={link.to}
                  className="group flex items-center space-x-2 text-base text-gray-300 transition-all hover:text-teal-400"
                >
                  <ExternalLink className="h-3.5 w-3.5 shrink-0 opacity-50 group-hover:opacity-100 transition-opacity" />
                  <span className="border-b border-transparent group-hover:border-teal-400">
                    {_(link.label)}
                  </span>
                </Link>
              ))}
            </nav>
          </div>

          <div className="lg:col-span-4 space-y-8">
            <div className="space-y-6">
              <h3 className="text-lg font-semibold border-b border-white/10 pb-2 inline-block">
                {_("footer.layout.2.header")}
              </h3>
              <ul className="space-y-4">
                <li className="flex items-start space-x-3 group">
                  <MapPin className="mt-1 h-5 w-5 shrink-0 text-teal-400 group-hover:scale-110 transition-transform" />
                  <span className="text-base text-gray-300 leading-snug">
                    {_("footer.layout.2.title.1")}
                  </span>
                </li>
                <li className="flex items-center space-x-3 group">
                  <Phone className="h-5 w-5 shrink-0 text-teal-400 group-hover:scale-110 transition-transform" />
                  <span className="text-base text-gray-300">
                    {_("footer.layout.2.title.2")}
                  </span>
                </li>
                <li className="flex items-center space-x-3 group">
                  <Mail className="h-5 w-5 shrink-0 text-teal-400 group-hover:scale-110 transition-transform" />
                  <span className="text-base text-gray-300 break-all">
                    {_("footer.layout.2.title.3")}
                  </span>
                </li>
              </ul>
            </div>

            <div className="pt-4">
              <p className="text-base font-semibold mb-4 uppercase tracking-widest">
                {_("footer.followUs.Title")}
              </p>
              <div className="flex gap-4">
                <FacebookIcon link="https://www.facebook.com/maharevenue" />
                <TwitterIcon link="https://x.com/maharevenue?lang=en" />
                <InstagramIcon link="https://www.instagram.com/maharevenue/" />
                <YouTubeIcon link="https://www.youtube.com/@maharevenue" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-white/5 bg-black/10">
        <div className="container mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-center md:text-left">
            <div className="space-y-1">
              <p className="text-base">
                {_("Footer.Rights.title")}
                <span className="text-teal-400 ml-1 font-medium">{_("Footer.Rights")}</span>
              </p>
            </div>
            <div className="flex items-center space-x-2 text-base py-1 px-3 bg-white/5 rounded-full border border-white/10">
              <span className="uppercase tracking-tighter">{_("Footer.LastUpdated")}:</span>
              <span className="text-teal-400 font-mono">{formattedDate}</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
    // </div>
  );
};

export default Footer;